      <div class="pt-2 pb-2 cursor-pointer" (click)="navigateToDetail(drugListObj?.drug_id)">
            <div class="row">
                  <div class="col-4">
                        <div class="position-relative"><img class="rounded  post-pic" style="height: 80px"
                                    src={{drugListObj?.logo}}
                                    onerror="this.src='assets/themes/icons/banner-placeholder.svg'" />
                        </div>
                  </div>
                  <div class="col-8 pl-0 secondary-paragraph">
                        <p class="mb-2 text-very-dark"><b>{{drugListObj?.name}}</b></p>
                        <p class="primary-small text-medium-grey mt-2">
                              <span class="color-grey-500">
                                    <span
                                    class="clinical-compny position-relative mr-3"><img
                                          class="mr-1  post-pic rounded-circle" src={{drugListObj?.pharma_logo}}
                                          onerror="this.src='assets/themes/icons/channel-placeholder.svg'" />{{drugListObj?.pharma_name}}
                                    </span>
                              <span class="py-1 px-2 warning-text">{{drugListObj?.paid_text}}</span></span>
                        </p>
                  </div>
            </div>
      </div>